import { Dispatch, SetStateAction } from 'react';

interface LayoutEvent {
  nativeEvent: {
    layout: {
      width: number;
      height: number;
    };
  };
}

interface Size {
  width: number;
  height: number;
}

export const handleLayoutEvent = (
  event: LayoutEvent,
  setContainerSize: Dispatch<SetStateAction<Size>>,
) => {
  const { width, height } = event.nativeEvent.layout;
  setContainerSize((prevSize) => {
    if (
      Math.abs(prevSize.width - width) < 1 &&
      Math.abs(prevSize.height - height) < 1
    ) {
      return prevSize; // No significant change, avoid unnecessary state updates and re-renders
    }
    return { width, height };
  });
};
